<template>
  <div
    class="va-continue"
    :class="{ 'va-continue-row': row }"
    role="button"
    tabindex="0"
    :aria-label="`Continue de onde parou: ${displayName}`"
    @click="$emit('select', item)"
    @keydown.enter.prevent="$emit('select', item)"
    @keydown.space.prevent="$emit('select', item)"
  >
    <span class="va-circle-icon va-continue-icon">
      <v-icon class="va-icon" :size="row ? 16 : 18" color="primary">{{
        _icon("history")
      }}</v-icon>
    </span>
    <span class="va-continue-text">
      <span class="va-continue-label">Continue de onde parou</span>
      <span class="va-continue-name va-truncate">{{ displayName }}</span>
    </span>
    <v-icon :size="row ? 14 : 16" color="#8a97ab">{{ mdiChevronRight }}</v-icon>
  </div>
</template>

<style>
.va-continue {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 4px;
  cursor: pointer;
  min-width: 0;
}

/* Desktop: linha dentro do trilho lateral. */
.va-continue-row {
  padding: 12px 0;
  border-bottom: 1px solid #e6e9ef;
}

.va-continue-icon {
  width: 36px;
  height: 36px;
}

.va-continue-row .va-continue-icon {
  width: 32px;
  height: 32px;
  background: #ffffff;
}

.va-continue-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 0;
}

.va-continue-label {
  font-size: 12px;
  line-height: 16px;
  color: #6b7a90;
}

.va-continue-name {
  font-size: 15px;
  line-height: 20px;
  color: #193153;
}

.va-continue-row .va-continue-name {
  font-size: 14px;
  line-height: 19px;
}
</style>

<script>
import { mdiChevronRight } from "@mdi/js";
import contentRoutes from "@/constants/content.routes.js";

export default {
  name: "HomeContinueCard",
  computed: {
    displayName() {
      return contentRoutes.getDisplayName(this.item);
    },
  },
  props: {
    /** Último conteúdo aberto neste dispositivo. */
    item: {
      type: Object,
      required: true,
    },
    /** Variante de linha (desktop, no trilho). */
    row: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      mdiChevronRight,
    };
  },
};
</script>
